<script>
  // @ts-nocheck

  import SocialMedia from './SocialMedia.svelte';

  export let appId;
  export let appName = '';
  export let shouldShowCraftedWithLove = true;
  export let isPasswordProtected = false;
  export let creatorName = '';
  export let contactEmail = '';
</script>

<SocialMedia {appId} {isPasswordProtected} />

{#if appName}
  <p class="align-middle text-slate-600">
    <small>
      {appName} is powered by <a class="underline" href="/">AppGen</a> 🤖
    </small>
  </p>
{/if}
{#if creatorName && contactEmail}
  <p class="align-middle text-slate-600">
    <small>
      If you have any feedback or suggestions please contact <a
        class="underline"
        href="mailto:{contactEmail}">{creatorName}</a
      >.
    </small>
  </p>
{/if}

<p class="align-middle text-slate-600">
  <a data-sveltekit-reload href="/apps">
    <small>Explore more apps <span class="text-indigo-600">here</span></small>
  </a>
</p>

{#if shouldShowCraftedWithLove}
  <p class="align-middle text-slate-600 flex">
    <small> Crafted with </small>
    <svg
      class="text-red-300 h-4 w-4 mx-1"
      fill="currentColor"
      stroke="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ><path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
      /></svg
    >
    <small>by <a class="underline" href="https://www.symph.co/">Symph</a></small>
  </p>
{/if}
